import React from 'react';
import styled from 'styled-components';

import { AIToolEvent } from '../../tool.types';
import { Expression } from '@common/Expression';
import { NodeAIArgument } from '@components/Flow/Nodes';
import { DeleteOutlined } from '@mui/icons-material';
import { IconButton } from '@mui/material';

const Container = styled.div`
  display: grid;
  grid-template-columns: 4fr 6fr 40px;
  flex: 1;
  gap: 0.5rem;

  & .MuiIconButton-root {
    border: 1px solid ${({ theme }) => theme.line.light};
  }
`;

interface Props {
  toolEvent: AIToolEvent;
  setToolEvents: React.Dispatch<React.SetStateAction<AIToolEvent[]>>;
  toolArguments: NodeAIArgument[];
}

export const SettingToolEvent: React.FC<Props> = ({ toolEvent, setToolEvents, toolArguments }) => {
  const updateEvent = (field: 'type' | 'value', value: string) => {
    setToolEvents((prevState) =>
      prevState.map((event) => {
        if (event.id === toolEvent.id) return { ...event, [field]: value };
        return event;
      })
    );
  };

  const deleteEvent = () => {
    setToolEvents((prevState) => prevState.filter((event) => event.id !== toolEvent.id));
  };

  const toolArgumentOptions = {
    tool: {
      args: toolArguments.reduce((acc, item) => {
        acc[item.name] = 'string';
        return acc;
      }, {} as Record<string, string>),
    },
  };

  return (
    <Container>
      <Expression
        key={`event_type`}
        keyProp={`event_type`}
        value={toolEvent.type}
        title={'Tool Event Type'}
        description='The event type is used to identify the type of event that is being sent.'
        setValue={(newValue: string) => updateEvent('type', newValue)}
        options={toolArgumentOptions}
        placeholder='Event Type'
      />
      <Expression
        key={`event_value`}
        keyProp={`event_value`}
        value={toolEvent.value}
        title={'Tool Value Type'}
        description='The event value is used to add additional information to the event type.'
        setValue={(newValue: string) => updateEvent('value', newValue)}
        options={toolArgumentOptions}
        placeholder='Event Value'
      />
      <IconButton onClick={deleteEvent}>
        <DeleteOutlined fontSize='small' />
      </IconButton>
    </Container>
  );
};
